<div class="container">
  @for (route of routes; track route) {
    <span
      [ngClass]="route.path === currentUrl ? 'active-link' : 'inActive-link'"
      ><a
        class="dark-link"
        href="javascript:void(0)"
        (click)="goToRoute(route.path)"
        >{{ route.title }}</a
      ></span
    >
  }
</div>
